module.exports = __webpack_public_path__ + "ea931ccc7685c8a20e312e61cff9a4ff.svg";